import Login from '../views/UserLogin'
import Signup from '../views/Signup'
import Support from '../views/support/Support'
import AccountSettings from '../views/account/AccountSettings'
import List from '../views/classes/List'
import LessonList from '../views/lessons/List'
import Overview from '../views/dashboard/Overview'
import ForgotPassword from '../views/UserForgotPassword'
import UserDashboard from '../views/UserDashboard'
import ResetPassword from '../views/UserResetPassword'

export default [
  {
    path: '/user/dashboard',
    name: 'User Dashboard',
    component: UserDashboard,
    redirect: '/user/dashboard/overview',
    meta: {
      private: true,
      type: 'user'
    },
    children: [
      {
        path: 'overview',
        name: 'User Overview',
        component: Overview,
        meta: {
          type: 'user'
        }
      },
      {
        path: 'classes',
        name: 'Teacher Classes',
        component: List,
        meta: {
          type: 'user'
        },
        children: [
          {
            path: 'edit',
            name: 'Edit',
            meta: {
              type: 'user'
            }
          }
        ]
      },
      {
        path: 'lessons',
        name: `User ${
          process.env.VUE_APP_LESSON_TERM
            ? process.env.VUE_APP_LESSON_TERM
            : 'Lesson'
        }`,
        component: LessonList,
        meta: {
          type: 'user'
        }
      },
      {
        path: 'support',
        name: 'User Support',
        component: Support,
        meta: {
          type: 'user'
        }
      },
      {
        path: 'account',
        name: 'User Account',
        component: AccountSettings,
        meta: {
          type: 'user'
        }
      }
    ]
  },
  {
    path: '/user/login',
    name: 'User Login',
    component: Login,
    meta: {
      type: 'user'
    }
  },
  {
    path: '/user/signup',
    name: 'User Signup',
    component: Signup,
    meta: {
      type: 'user'
    }
  },
  {
    path: '/user/forgotpassword',
    name: 'User Password Reset',
    component: ForgotPassword,
    meta: {
      type: 'user'
    }
  },
  {
    path: '/user/reset-password',
    name: 'User Resert Passowrd',
    component: ResetPassword,
    meta: {
      type: 'user'
    }
  }
]
